import React, {useState} from 'react'
import contactStyle from './contactInfo.module.css'
require('typeface-poppins')


export default function ContactInfo({fName, lName, cMail, cMobil, web, zip}) {

    const [openIndex, setOpenIndex] = useState(null); // state to track open accordion item, null means none are open

    const handleToggle = (index) => {
      // Toggle between opening and closing the same accordion item
      setOpenIndex(openIndex === index ? null : index);
    }; 

    return (
    <>
    <div className={`${contactStyle.contactAccordion} accordion mb-3`} id="ContactInfo">
        <div className={`${contactStyle.contactMainitem} accordion-item`}>
            <h2 className="accordion-header">
                <button className={`${contactStyle.contactbuttonItem} ${contactStyle.contactBeforebg} accordion-button ${openIndex === 0 ? '' : `${contactStyle.contactbgColor} collapsed`}`} type="button" onClick={() => handleToggle(0)} aria-expanded={openIndex === 0 ? 'true' : 'false'} aria-controls="collapseOne">
                   Contact Info
                </button>
            </h2>
            <div id="collapseOne" className={`accordion-collapse collapse ${openIndex === 0 ? 'show' : ''}`} data-bs-parent="#ContactInfo">
                <div className="accordion-body">
                    <div className={contactStyle.contactinfoWrapper}>
                        <div className={contactStyle.contactInner}>
                            <div className={`${contactStyle.contactTitle} w-50`}>
                                <h6> Name </h6>
                            </div>
                            <div className={`${contactStyle.contactDetails} w-50`}>
                                <p> {fName} {lName} </p>
                            </div>
                        </div>
                        <div className={contactStyle.contactInner}>
                            <div className={`${contactStyle.contactTitle} w-50`}>
                                <h6> Website </h6>
                            </div>
                            <div className={`${contactStyle.contactDetails} w-50`}>
                                <p> <a href="#">{web} </a> </p>
                            </div>
                        </div>
                        <div className={contactStyle.contactInner}>
                            <div className={`${contactStyle.contactTitle} w-50`}>
                                <h6> Email Address </h6>
                            </div>
                            <div className={`${contactStyle.contactDetails} w-50`}>
                                <p> {cMail} </p>
                            </div>
                        </div>
                        <div className={contactStyle.contactInner}>
                            <div className={`${contactStyle.contactTitle} w-50`}>
                                <h6> Phone </h6>
                            </div>
                            <div className={`${contactStyle.contactDetails} w-50`}>
                                <p> {cMobil} </p>
                            </div>
                        </div>
                        <div className={contactStyle.contactInner}>
                            <div className={`${contactStyle.contactTitle} w-50`}>
                                <h6> Hometown Zip Code </h6>
                            </div>
                            <div className={`${contactStyle.contactDetails} w-50`}>
                                <p> {zip} </p>
                            </div>
                        </div>
                    </div>   
                </div>
            </div>
        </div>
    </div>          
    </>
  )
}
